import axios, { AxiosResponse } from 'axios';

import { IMailerPayload } from '../models/mailer-payload.interface';

export const mailerService = (payload: IMailerPayload): Promise<AxiosResponse<any, any>> => {
  return axios.post(`/mailer`, payload);
};
